import {
  GreyGrey60,
  Primary12SemiBold,
  Primary13Regular
} from '@sequencehq/core-components/theme'

export const STYLES = {
  tableHeader: {
    ...Primary12SemiBold,
    color: GreyGrey60,
    textTransform: 'uppercase' as const,
    border: 'none',
    padding: '10px 8px',
    marginRight: '8px'
  },
  tableCell: {
    alignItems: 'center',
    ...Primary13Regular,
    border: 'none',
    textAlign: 'left' as const,
    padding: '8px',
    zIndex: 1,
    marginRight: '8px'
  }
}

export const COMPACT_COLUMN_WIDTHS = '1fr 103px 127px 232px 24px'
